export const decodeHtml = (html) => {
  const text = document.createElement('textarea')
  text.innerHTML = html

  return text.value
}



// WEBPACK FOOTER //
// ./src/common/lib/decode-html.js